import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toSeconds',
  pure: true,
})
export class ToSecondsPipe implements PipeTransform {

  transform(
    value: number | null | undefined,
    scale: 'milliseconds' | 'seconds' | 'minutes' | 'hours' | 'days' = 'milliseconds',
  ): number | null | undefined {

    if (value === null || value === undefined || scale === 'seconds') {
      return value;
    }

    if (scale === 'milliseconds') {
      return Math.round(value / 1_000);

    } else if (scale === 'minutes') {
      return value * 60;

    } else if (scale === 'hours') {
      return value * 60 * 60;

    } else if (scale === 'days') {
      return value * 60 * 60 * 24;
    }

    return NaN;
  }

}
